<template>
	<div v-if="!hide" class="landing-alert" :style="{ backgroundColor: computedBackgroundColor, ...customStyles }">
		<div v-if="icon" class="landing-alert__icon">
			<img :src="icon" alt="" />
		</div>

		<div class="landing-alert__text" v-html="text"></div>
	</div>
</template>

<script>
export default {
	name: 'LandingAlert',
	props: {
		text: {
			type: String,
			default: '',
		},

		icon: {
			type: String,
			default: null,
		},

		backgroundColor: {
			type: String,
			default: null,
		},

		hide: {
			type: Boolean,
			default: false,
		},

		customStyles: {
			type: Object,
			default: () => ({}),
		},
	},

	computed: {
		computedBackgroundColor() {
			return this.backgroundColor
		},
	},
}
</script>

<style scoped lang="scss">
.landing-alert {
	display: flex;
	align-items: center;
	border-radius: var(--size-16);
	padding: var(--size-16) var(--size-20);
	margin-bottom: var(--size-16);
	font-size: var(--size-18);
	line-height: var(--size-22);
	font-weight: 600;
	gap: var(--size-20);

	&__icon {
		width: var(--size-56);
		flex-shrink: 0;
	}
}
</style>
